// extracted by mini-css-extract-plugin
export default {"container":"close_container__j0hs9","line1":"close_line1__Xu7b0","line2":"close_line2__kwBru","small":"close_small__Eogk5","white":"close_white__zDEF7"};